import script from "./PlatformRequirementsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformRequirementsModal.vue?vue&type=script&setup=true&lang=js"

import "./PlatformRequirementsModal.vue?vue&type=style&index=0&id=259aa878&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-259aa878"]])

export default __exports__